import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const StyledPostContainer = styled.main`
  max-width: 1000px;
`;
const StyledPostHeader = styled.header`
  margin-bottom: 50px;
  .tag {
    margin-right: 10px;
  }
`;
const StyledPostContent = styled.div`
  margin-bottom: 100px;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 2em 0 1em;
  }

  p {
    margin: 1em 0;
    line-height: 1.5;
    color: var(--light-slate);
  }

  a {
    ${({ theme }) => theme.mixins.inlineLink};
  }

  code {
    background-color: var(--lightest-navy);
    color: var(--lightest-slate);
    border-radius: var(--border-radius);
    font-size: var(--fz-sm);
    padding: 0.2em 0.4em;
  }

  pre code {
    background-color: transparent;
    padding: 0;
  }
`;

const PostComponent = ({ data }) => {
  const { t } = useTranslation();
  if (!data || !data.markdownRemark) {
    return (
      <div>
        <h1>Errrrooooo</h1>
      </div>
    ); // Exibe mensagem de erro ou um componente de fallback
  }
  const { frontmatter } = data.markdownRemark;
  const { title, date, tags } = frontmatter;

  const postKey = title.toLowerCase().replace(/\s+/g, '_');
  const postTitle = t(`articles.post_card.${postKey.toLowerCase()}.title`);
  const postContent = t(`articles.post_card.${postKey.toLowerCase()}.content`);

  return (
    <>
      <Helmet title={postTitle} />
      <StyledPostContainer>
        <span className="breadcrumb">
          <span className="arrow">&larr;</span>
          <Link to="/articles">{t('articles.insight')}</Link>
        </span>

        <StyledPostHeader>
          <h1 className="medium-heading">{postTitle}</h1>
          <p className="subtitle">
            <time>
              {new Date(date).toLocaleDateString(t('language'), {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </time>
            <span>&nbsp;&mdash;&nbsp;</span>
            {tags &&
              tags.length > 0 &&
              tags.map((tag, i) => (
                <Link key={i} to={`/articles/tags/${kebabCase(tag)}/`} className="tag">
                  #{tag}
                </Link>
              ))}
          </p>
        </StyledPostHeader>

        <StyledPostContent dangerouslySetInnerHTML={{ __html: postContent }} />
      </StyledPostContainer>
    </>
  );
};

PostComponent.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PostComponent;
